var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_c('strong',[_vm._v(_vm._s(_vm.qtyLabel))]),_c('span',{staticClass:"is-gray-400"},[_vm._v(" "+_vm._s(_vm.label))]),(_vm.tooltipText)?_c('Tooltip',{attrs:{"tooltipText":_vm.tooltipText}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }